import { usePreference } from '../preferences'
import { type FeatureState } from '../feature'

export const useMultiAccountFeature = (): FeatureState => {
  const { data: allowDuplicateAccounts, isLoading } = usePreference('allowDuplicateAccounts')
  return { isEnabled: allowDuplicateAccounts === 'Multiple', isLoading }
}

export const getCanvassAPIVersion = (shouldUseFirstAmericanData: boolean): number | undefined => {
  if (!shouldUseFirstAmericanData) return undefined
  return 3
}
